import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import { applyCurrencyRounding, getRoundingMethod } from "../../../../utils/tillHelpers";
import { groupItemsByTaxRate } from "../utils/taxCalculations";
import { getIsInterState } from "../../../../utils/taxUtils";

export const TotalBillDiscount = (pricingRule, setCart, cart, orderType, cartObj, iscoupon, couponInput, uniqReferenceId, mPricingCouponId, mPricingRulesId) => {
  let couponError = "";
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const saleTypeValidation = pricingRule.cwrSaletypeId === null ? true : pricingRule.cwrSaletypeId === orderType.cwrSaletype.cwrSaletypeId;
  const tillData = useAuthStore.getState().tillData;
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const saleTypeData = usePOSConfigStore.getState().saleTypeData || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const billCart = { ...cartObj };
  let nonReturnItemsTotal = 0;
  let nonReturnItemsQty = 0;
  let nonReturnItemsDiscount = 0;
  let nonReturnItems = [];
  billCart.items.map((item) => {
    if (!item.isReturn) {
      nonReturnItemsTotal += item.nettotal;
      nonReturnItemsQty += item.weight;
      nonReturnItemsDiscount += item.discount;
      nonReturnItems.push(item);
    }
  });

  const hasProductRestriction = pricingRule?.applicableProducts?.length > 0;
  let eligibleItems = nonReturnItems;

  if (hasProductRestriction) {
    eligibleItems = nonReturnItems.filter((item) => pricingRule.applicableProducts.some((p) => p._id === item.productId));
    if (eligibleItems.length === 0) {
      couponError = "Coupon not applicable for selected products";
    }
  }

  let maxAmount = pricingRule.maxBillAmount ? Math.abs(nonReturnItemsTotal) <= pricingRule.maxBillAmount : true;
  const minQtyFlag = pricingRule.minimumQty ? Math.abs(nonReturnItemsQty) >= pricingRule.minimumQty : true;
  const maxQtyFlag = pricingRule.maximumQty ? Math.abs(nonReturnItemsQty) <= pricingRule.maximumQty : true;
  const minAmountFlag = pricingRule.billAmount ? Math.abs(nonReturnItemsTotal) >= pricingRule.billAmount : true;
  const maxAmountFlag = pricingRule.maxBillAmount ? Math.abs(nonReturnItemsTotal) <= pricingRule.maxBillAmount : true;

  if (!minAmountFlag) {
    couponError = `Minimum bill amount should be ${pricingRule.billAmount}`;
  }
  if (!maxAmountFlag) {
    couponError = "Maximum bill amount exceeded";
  }
  if (!minQtyFlag) {
    couponError = `Minimum quantity should be ${pricingRule.minimumQty}`;
  }
  if (!maxQtyFlag) {
    couponError = "Maximum quantity exceeded";
  }

  let giftCardFlag = false;
  let categoryItems = [];
  let brandItems = [];

  nonReturnItems.forEach((item) => {
    const stateValidation = pricingRule.mPricingXProducts.some((pc) => pc.mProductId === item.productId);
    const brandValidation = pricingRule.mPricingBrands.some((pc) => pc.mBrandId === item.productBrandId);
    const categoryValidation = pricingRule.mPricingPcategories.some((pc) => pc.mProductCategoryId === item.mProductCategoryId);
    if (item.isGiftCard) {
      giftCardFlag = true;
    }
    if (stateValidation || brandValidation || categoryValidation) {
      if (stateValidation || brandValidation) {
        brandItems.push(item);
      }
      if (categoryValidation) {
        categoryItems.push(item);
      }
    }
  });

  if (giftCardFlag) {
    couponError = "Coupon not applicable on gift cards";
  }

  let allItems = brandItems.concat(categoryItems).length > 0 ? brandItems.concat(categoryItems) : nonReturnItems;
  let uniqueFinalArray = [...new Set(allItems)];

  // let totalBillPrice = eligibleItems.reduce((sum, p) => sum + p.realPrice * Math.abs(p.weight), 0);
  const hasApplicableProducts = Array.isArray(pricingRule?.applicableProducts) && pricingRule.applicableProducts.length > 0;

  let totalBillPrice = eligibleItems
    .filter((item) => (hasApplicableProducts ? pricingRule.applicableProducts.some((p) => p?._id === item?.productId) : true))
    .reduce((sum, p) => sum + p.realPrice * Math.abs(p.weight), 0);

  if (couponError) {
    return {
      ...cartObj,
      couponError,
    };
  }

  if (
    Math.abs(nonReturnItemsTotal) + Math.abs(nonReturnItemsDiscount) >= pricingRule.billAmount &&
    maxAmount &&
    minQtyFlag &&
    maxQtyFlag &&
    minAmountFlag &&
    maxAmountFlag &&
    totalBillPrice >= pricingRule.billAmount &&
    !giftCardFlag
  ) {
    let discountValue = 0;
    discountValue = pricingRule.discountType === "V" ? pricingRule.amountDiscount : (pricingRule.percentageDiscount / 100) * nonReturnItemsTotal;
    let discountType = pricingRule.discountType === "V" ? "FD" : "PD";
    if (pricingRule.issueGiftVoucher === "N" || pricingRule.issueGiftVoucher === null) {
      const cartItemsFiltered = billCart.items.filter((i) => i.nextRule === "Y" || i.nextRule === undefined);
      let salePricesTotal = 0;
      for (let i = 0; i < cartItemsFiltered.length; i += 1) {
        salePricesTotal += parseFloat(cartItemsFiltered[i].realPrice * cartItemsFiltered[i].weight);
      }
      let discountFlag = false;
      billCart.items.map((addedToCart, index) => {
        let excludingFlag = true;

        const hasApplicableProducts = Array.isArray(pricingRule?.applicableProducts) && pricingRule.applicableProducts.length > 0;

        const isEligibleProduct = hasApplicableProducts ? pricingRule.applicableProducts.some((p) => p?._id === addedToCart?.productId) : true;

        if (!isEligibleProduct) {
          return;
        }

        if (pricingRule.mPricingB2CCustomerSegments.length > 0) {
          const matchingCustomerSegment = pricingRule.mPricingB2CCustomerSegments.find(
            (pc) => pc.cwrB2CCustomerSegmentId === cartObj.customer?.b2cCustomerSegment?.cwrB2CCustomerSegmentId
          );

          if (
            (pricingRule.excludeB2CSegment === "Y" && matchingCustomerSegment) ||
            (pricingRule.excludeB2CSegment !== "Y" && !matchingCustomerSegment && pricingRule.mPricingB2CCustomerSegments.length > 0) ||
            (pricingRule.excludeB2CSegment === "N" && pricingRule.mPricingB2CCustomerSegments.length === 0)
          ) {
            excludingFlag = false;
          }
        }

        if (pricingRule.mPricingB2CCustomers.length > 0) {
          const matchingCustomer = pricingRule.mPricingB2CCustomers.find((pc) => pc.b2cCustomerId === cartObj.customer.cwrCustomerId);

          if (
            (pricingRule.excludeB2CCustomers === "Y" && matchingCustomer) ||
            (pricingRule.excludeB2CCustomers !== "Y" && !matchingCustomer && pricingRule.mPricingB2CCustomers.length > 0) ||
            (pricingRule.excludeB2CCustomers === "N" && pricingRule.mPricingB2CCustomers.length === 0)
          ) {
            excludingFlag = false;
          }
        }

        const matchingCategoy = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === addedToCart.mProductCategoryId);

        if (
          (pricingRule.excludeProductCategories === "Y" && matchingCategoy) ||
          (pricingRule.excludeProductCategories !== "Y" && !matchingCategoy && pricingRule.mPricingPcategories.length > 0) ||
          (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
        ) {
          excludingFlag = false;
        }

        billCart.items.map((item) => {
          const stateValidation = pricingRule.mPricingPcategories.some((pc) => pc.mProductCategoryId === item.mProductCategoryId);
          if (stateValidation) {
            categoryItems.push(item);
          }
          return null;
        });

        const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === addedToCart.productBrandId);

        if (
          (pricingRule.excludeBrands === "Y" && matchingBrand) ||
          (pricingRule.excludeBrands !== "Y" && !matchingBrand && pricingRule.mPricingBrands.length > 0) ||
          (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
        ) {
          excludingFlag = false;
        }
        nonReturnItems.map((item) => {
          const stateValidation = pricingRule.mPricingBrands.some((pc) => pc.mBrandId === item.productBrandId);
          if (stateValidation) {
            brandItems.push(item);
          }
          return null;
        });

        const matchingBusinessUnit = pricingRule.mPricingBUnits.find((pc) => pc.mBunitPricingId === tillData.tillAccess.csBunit.csBunitId);
        if (
          (pricingRule.excludeBusinessUnits === "Y" && matchingBusinessUnit) ||
          (pricingRule.excludeBusinessUnits !== "Y" && !matchingBusinessUnit && pricingRule.mPricingBUnits.length > 0) ||
          (pricingRule.excludeBusinessUnits === "N" && pricingRule.mPricingBUnits.length === 0)
        ) {
          excludingFlag = false;
        }

        const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === addedToCart.productId);

        if (
          (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
          (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1 && pricingRule.mPricingXProducts.length > 0) ||
          (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
        ) {
          excludingFlag = false;
        }

        let pricingRuleFlag = true;

        if (addedToCart.discount <= 0) {
          const matchingProduct = pricingRule.mPricingXProducts.find((res) => res.mProductId === addedToCart.productId);
          if (matchingProduct) {
            // console.debug("Deleting priority for addedToCart:", addedToCart.productId);
            delete addedToCart.priority;
          }
        }

        if (
          (addedToCart.nextRule === "N" &&
            pricingRuleFlag &&
            excludingFlag &&
            saleTypeValidation &&
            !addedToCart.isReturn &&
            (iscoupon ? (addedToCart?.priority ? addedToCart?.priority < pricingRule.priority : true) : true)) ||
          (addedToCart.nextRule === undefined &&
            pricingRuleFlag &&
            excludingFlag &&
            saleTypeValidation &&
            !addedToCart.isReturn &&
            (iscoupon ? (addedToCart?.priority ? addedToCart?.priority < pricingRule.priority : true) : true))
        ) {
          let eligibleQty = addedToCart.weight;
          if (hasProductRestriction) {
            const matchedProduct = pricingRule.applicableProducts.find((p) => p._id === addedToCart.productId);
            if (matchedProduct) {
              eligibleQty = Math.min(addedToCart.weight, matchedProduct.quantity);
            }
          }
          let discountAmt;
          let tax;
          let nettotal;
          if (discountType === "FD") {
            const itemTotal = Number(addedToCart.realPrice || 0) * Number(addedToCart.weight || 0);

            discountAmt = totalBillPrice > 0 ? (Number(pricingRule.amountDiscount || 0) * itemTotal) / totalBillPrice : 0;

            addedToCart.discount = Math.min(discountAmt, itemTotal);

            // TSK-2805: match CheckoutTotalManualDiscount.js's fixed-amount formula —
            // discount reduces the gross (tax-inclusive) total for the eligible
            // quantity; tax is the portion of what's left. Non-eligible quantity
            // (partial product-restricted coupons) keeps its original price/tax.
            const nonEligibleQty = addedToCart.weight - eligibleQty;
            const taxInclude = (addedToCart.realPrice * addedToCart.taxRate) / 100;
            const eligibleGross = (taxIncludeFlag === "Y" ? addedToCart.realPrice : addedToCart.realPrice + taxInclude) * eligibleQty;
            const eligibleNet = eligibleGross - addedToCart.discount;
            const eligibleTax = eligibleNet - eligibleNet / (1 + addedToCart.taxRate / 100);

            const nonEligibleGross = addedToCart.realPrice * nonEligibleQty;
            const nonEligibleTax =
              taxIncludeFlag === "Y" ? nonEligibleGross - nonEligibleGross / (1 + addedToCart.taxRate / 100) : (nonEligibleGross * addedToCart.taxRate) / 100;
            const nonEligibleNet = taxIncludeFlag === "Y" ? nonEligibleGross : nonEligibleGross + nonEligibleTax;

            tax = eligibleTax + nonEligibleTax;
            nettotal = eligibleNet + nonEligibleNet;
            addedToCart.salePrice = nettotal;
          } else {
            const realPriceNum = parseFloat(addedToCart.realPrice);
            discountAmt = (pricingRule.percentageDiscount / 100) * realPriceNum;
            // TSK-3145: cap at the item's own per-unit realPrice so a misconfigured
            // percentageDiscount > 100 can never push sp/nettotal negative (mirrors the
            // Math.min guard already used a few lines up in the FD branch).
            discountAmt = realPriceNum >= 0 && discountAmt > realPriceNum ? realPriceNum : discountAmt;
            addedToCart.discount = discountAmt * eligibleQty;
            const sp = realPriceNum - discountAmt;
            const mrp = parseFloat(sp) * eligibleQty + addedToCart.realPrice * (addedToCart.weight - eligibleQty);
            tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addedToCart.taxRate / 100) : (mrp * addedToCart.taxRate) / 100;
            nettotal = taxIncludeFlag === "Y" ? mrp : mrp + tax;
            addedToCart.salePrice = sp;
          }
          discountFlag = true;
          addedToCart.taxAmount = tax;
          addedToCart.nettotal = nettotal;
          addedToCart.discountName = pricingRule.printedName;
          addedToCart.mPricingruleId = pricingRule.mPricingrulesId;
          addedToCart.iscoupon = iscoupon;
          addedToCart.couponInput = couponInput;
          addedToCart.referenceId = uniqReferenceId;
          addedToCart.mPricingCouponId = mPricingCouponId;
          addedToCart.priority = pricingRule.priority;
          billCart.items[index] = addedToCart;
        }
      });

      billCart.mPricingruleId = pricingRule.mPricingrulesId;
      billCart.billDiscount = billCart.billDiscount ? billCart.billDiscount + discountValue : discountValue;

      const addedToCart = billCart.items;

      let totalTax = 0;
      let totalPrice = 0;
      let totalItemsQty = 0;
      let totalDiscounts = 0;
      for (let i = 0; i < addedToCart.length; i += 1) {
        totalPrice += addedToCart[i].nettotal;
        totalItemsQty += addedToCart[i].weight;
        totalTax += addedToCart[i].taxAmount;
        totalDiscounts += addedToCart[i].discount;
        addedToCart[i].key = i;
      }

      // max discount cap — proportionally adjust across items
      if (pricingRule?.maxDiscount && totalDiscounts > pricingRule?.maxDiscount) {
        let reductionRatio = pricingRule.maxDiscount / totalDiscounts;
        billCart.items.forEach((item) => {
          item.discount = Number(item.discount || 0) * reductionRatio;

          const itemTotal = Number(item.realPrice || 0) * Number(item.weight || 0);

          if (discountType === "FD") {
            // TSK-2805: same fixed-amount formula as the per-line FD branch above —
            // discount reduces the gross (tax-inclusive) total; tax is the portion
            // of what's left.
            const grossWithTax = taxIncludeFlag === "Y" ? itemTotal : itemTotal + (itemTotal * item.taxRate) / 100;
            const netPayable = grossWithTax - Number(item.discount || 0);
            const tax = netPayable - netPayable / (1 + item.taxRate / 100);

            item.salePrice = netPayable;
            item.taxAmount = tax;
            item.nettotal = netPayable;
          } else {
            // PD: unchanged — matches the per-line PD branch's formula.
            const discountedTotal = itemTotal - Number(item.discount || 0);
            const updatedSalePrice = Number(item.weight || 0) > 0 ? discountedTotal / Number(item.weight) : 0;
            const tax = taxIncludeFlag === "Y" ? discountedTotal - discountedTotal / (1 + item.taxRate / 100) : (discountedTotal * item.taxRate) / 100;

            item.salePrice = updatedSalePrice;
            item.taxAmount = tax;
            item.nettotal = taxIncludeFlag === "Y" ? discountedTotal : discountedTotal + tax;
          }
        });
        totalDiscounts = pricingRule.maxDiscount;
        totalTax = 0;
        totalPrice = 0;

        billCart.items.forEach((item) => {
          totalPrice += Number(item.nettotal || 0);
          totalTax += Number(item.taxAmount || 0);
        });
      }

      const { roundedTotal: roundOffValue, roundOffAmount: totalRoundOff } = applyCurrencyRounding(totalPrice, getRoundingMethod(tillData));
      let couponsData = cart?.couponInput?.length > 0 ? [...cart?.couponInput] : [];

      if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null) {
        couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: pricingRule.mPricingrulesId });
      }

      const tcsValue = cartObj?.tcs || 0;
      // BUG-1880: total-bill promotions/coupons update item.nettotal/taxAmount above but
      // never recomputed the tax-breakup grouping, so the printed Tax Breakup kept showing
      // pre-discount amounts even though Gross Total reflected the discount correctly.
      const isInterStateForTax = getIsInterState(cartObj);
      const groupedItemsByTaxRate = groupItemsByTaxRate(
        addedToCart.filter((item) => item.weight !== 0),
        precision,
        { isInterState: isInterStateForTax }
      );
      let obj = {
        ...cartObj,
        items: [...addedToCart],
        total: roundOffValue + tcsValue,
        tax: totalTax,
        subTotal: parseFloat(parseFloat(totalPrice - totalTax).toFixed(precision)),
        discount: totalDiscounts,
        totalQty: totalItemsQty,
        roundOff: totalRoundOff,
        iscoupon: iscoupon ? iscoupon : false,
        couponInput: couponsData,
        totalBillDicount: iscoupon ? pricingRule.mPricingrulesId : false,
        totalDiscountFlag: true,
        couponError: null,
        groupedItemsByTaxRate,
        saleType: usePOSConfigStore.getState().saleTypeData?.cwrSaletype || {},
      };
      if (isExchange) {
        useCartStore.getState().setExchangeCart(obj);
      } else if (!iscoupon && !isExchange) {
        setCart(obj);
      }
      return obj;
    } else {
      let couponsData = cart.couponInput ? [...cart.couponInput] : [];
      if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null) {
        couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: pricingRule.mPricingrulesId });
      }
      billCart.giftVoucherType = pricingRule.giftVoucherType;
      billCart.giftVoucherAmount = discountValue;
      billCart.iscoupon = cart.iscoupon ? cart.iscoupon : false;
      billCart.couponInput = couponsData;
      billCart.totalBillDicount = !iscoupon ? null : pricingRule.mPricingrulesId;
      if (isExchange) {
        useCartStore.getState().setExchangeCart({ ...billCart });
      } else {
        setCart({ ...billCart });
      }
      return { ...billCart };
    }
  } else {
    const cartItemsFiltered = billCart.items.filter((i) => i.nextRule === "Y" || i.nextRule === undefined);
    let salePricesTotal = 0;
    for (let i = 0; i < cartItemsFiltered.length; i += 1) {
      salePricesTotal += parseFloat(cartItemsFiltered[i].realPrice);
    }

    billCart.items.map((addedToCart, index) => {
      if (addedToCart.discountName === pricingRule.printedName && !addedToCart.isReturn) {
        const sp = parseFloat(addedToCart.realPrice);
        const mrp = parseFloat(sp) * addedToCart.weight;
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addedToCart.taxRate / 100) : (mrp * addedToCart.taxRate) / 100;
        addedToCart.salePrice = sp;
        addedToCart.taxAmount = tax;
        addedToCart.nettotal = taxIncludeFlag === "Y" ? mrp : mrp + tax;
        addedToCart.discount = 0;
        addedToCart.discountName = "";
        billCart.items[index] = addedToCart;
      }
    });
    billCart.mPricingruleId = pricingRule.mPricingrulesId;
    billCart.billDiscount = 0;

    const addedToCart = billCart.items;

    let totalTax = 0;
    let totalPrice = 0;
    let totalItemsQty = 0;
    let totalDiscounts = 0;
    for (let i = 0; i < addedToCart.length; i += 1) {
      totalPrice += addedToCart[i].nettotal;
      totalItemsQty += addedToCart[i].weight;
      totalTax += addedToCart[i].taxAmount;
      totalDiscounts += addedToCart[i].discount;
      addedToCart[i].key = i;
    }

    const { roundedTotal: roundOffValue, roundOffAmount: totalRoundOff } = applyCurrencyRounding(totalPrice, getRoundingMethod(tillData));
    let couponsData = cart?.couponInput?.length > 0 ? [...cart.couponInput] : [];
    if (!couponsData?.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null) {
      couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: pricingRule.mPricingrulesId });
    }
    const tcsValue2 = cartObj?.tcs || 0;
    // BUG-1880: this branch resets items back to full (non-discounted) price when the
    // rule no longer qualifies — the tax breakup must be recomputed here too, otherwise
    // it keeps showing the previously-discounted amounts.
    const isInterStateForTax2 = getIsInterState(cartObj);
    const groupedItemsByTaxRate2 = groupItemsByTaxRate(
      addedToCart.filter((item) => item.weight !== 0),
      precision,
      { isInterState: isInterStateForTax2 }
    );
    let obj = {
      ...cartObj,
      items: [...addedToCart],
      total: roundOffValue + tcsValue2,
      tax: totalTax,
      subTotal: parseFloat(parseFloat(totalPrice - totalTax).toFixed(precision)),
      discount: totalDiscounts,
      totalQty: totalItemsQty,
      roundOff: totalRoundOff,
      iscoupon: iscoupon ? iscoupon : false,
      couponInput: couponsData,
      totalBillDicount: !iscoupon ? null : pricingRule.mPricingrulesId,
      discountType: "TD",
      totalDiscountFlag: true,
      couponError: "Coupon not applicable",
      groupedItemsByTaxRate: groupedItemsByTaxRate2,
      saleType: usePOSConfigStore.getState().saleTypeData?.cwrSaletype || {},
    };
    if (isExchange) {
      useCartStore.getState().setExchangeCart(obj);
    } else if (!iscoupon && !isExchange) {
      setCart(obj);
    }
    return {
      ...cartObj,
      items: [...addedToCart],
      total: roundOffValue + tcsValue2,
      tax: totalTax,
      subTotal: parseFloat(parseFloat(totalPrice - totalTax).toFixed(precision)),
      discount: totalDiscounts,
      totalQty: totalItemsQty,
      roundOff: totalRoundOff,
      iscoupon: iscoupon ? iscoupon : false,
      couponInput: couponsData,
      discountType: "TD",
      totalBillDicount: !iscoupon ? null : pricingRule.mPricingrulesId,
      totalDiscountFlag: true,
      couponError: "Coupon not applicable",
      groupedItemsByTaxRate: groupedItemsByTaxRate2,
      saleType: usePOSConfigStore.getState().saleTypeData?.cwrSaletype || {},
    };
  }
};
